<template>
  <div
    id="page-container"
    class="enable-page-overlay side-scroll main-content-boxed"
  >
    <header-component></header-component>
    <main id="main-container">
      <iframe
        :src="'/widget-editor/editor.html?id=' + this.$route.params.id"
        height="1000px"
        frameborder="0"
      ></iframe>
    </main>
  </div>
</template>

<script>
import HeaderComponent from "../../components/layout/Header";
export default {
  name: "WidgetEditor",
  components: {
    HeaderComponent
  }
};
</script>
